/* eslint no-param-reassign: "off" */

let $EventBus;

export function getEventBus() {
  return $EventBus;
}

export default {
  install: (Vue) => {
    $EventBus = new Vue();
    Vue.prototype.$EventBus = $EventBus;
  },
};



// WEBPACK FOOTER //
// ./src/plugin/eventBus.js